import EmbedRoot from '@/layouts/embed-root';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/design-studio-embed')({
  component: EmbedRoot,
});
